// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  setWebSettings: ['webSettings'],
  onChangeWebType: ['webType'],
  setAbTest: ['abTestId'],
  setFastQuote: ['enabled'],
})

export const SettingsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const WEB_TYPES = {
  DEFAULT: 0,
  SRO: 1,
  SUR: 2,
  POV: 3,
  REN: 4,
}

export type WEB_TYPES_KEYS_TYPE = 'srovnator.cz' | 'suri.cz' | 'povinne-ruceni.com' | 'renomiabenefitportal.cz'

export const WEB_TYPES_KEYS = {
  0: 'suri.cz',
  1: 'srovnator.cz',
  2: 'suri.cz',
  3: 'povinne-ruceni.com',
  4: 'renomiabenefitportal.cz',
}

export const INITIAL_STATE = Immutable({
  // eslint-disable-line
  webType: WEB_TYPES.DEFAULT,
  webSettings: {},
  activeSettings: {},
  abTestId: '',
  fastQuote: false,
})

/* ------------- Reducers ------------- */

export const setWebSettingsR = (state, { webSettings }) =>
  state.merge({
    webSettings,
    activeSettings: webSettings[WEB_TYPES_KEYS[state.webType]] ? webSettings[WEB_TYPES_KEYS[state.webType]] : {},
  })

export const onChangeWebTypeR = (state, { webType }) =>
  state
    .setIn(['webType'], Object.values(WEB_TYPES).indexOf(webType) !== -1 ? webType : WEB_TYPES.DEFAULT)
    .setIn(
      ['activeSettings'],
      state.webSettings[WEB_TYPES_KEYS[state.webType]] ? state.webSettings[WEB_TYPES_KEYS[state.webType]] : {},
    )

const setAbTestR = (state, { abTestId }) => state.set('abTestId', abTestId)

const setFastQuoteR = (state, { enabled }) => state.set('fastQuote', enabled)

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_WEB_SETTINGS]: setWebSettingsR,
  [Types.ON_CHANGE_WEB_TYPE]: onChangeWebTypeR,
  [Types.SET_AB_TEST]: setAbTestR,
  [Types.SET_FAST_QUOTE]: setFastQuoteR,
})

/* ------------- Hookup Reducers To Types ------------- */
